import React, { FC, ReactElement } from 'react';
import cns from 'classnames';
import { Link } from 'react-router-dom';
import Icon from '../../../Icon';
import { useSelector } from 'react-redux';
import { getIsLoggedIn, getIsRegistrationRequired, getContentDataIntro } from '../../../../stores/reducers/userData';
import routes from '../../../../config/routes';
import { ZoneDataProps } from '../DemoZone';
import './demo-zone-header.sass';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  zoneData: ZoneDataProps
}

const DemoZoneHeader: FC<Props> = ({ zoneData }): ReactElement => {
  const isLoggedIn = useSelector(getIsLoggedIn)
  const isRegistrationRequired = useSelector(getIsRegistrationRequired)
  const shouldRegister = !isLoggedIn && isRegistrationRequired
  const { backendURL } = useSelector(getContentDataIntro);
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    webinarBtnTitle_ru: 'Пообщаться с экспонентом',
    webinarBtnTitle_en: 'Chat with the exhibitor',
    webinarBtnDesc_ru: 'Для живого общения нажмите на кнопку',
    webinarBtnDesc_en: 'For live communication, click on the button',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  return (
    <section className={cns('main-section', 'demozone__header')} style={{backgroundImage: `url(${backendURL}${zoneData.image})`}}>
      <div className="container">
        <div className="demozone__title flex items-center mb-24">
          <Link
            className="btn-back transparent-btn flex mr-24"
            to={`${routes.DEMOZONE}`}
          >
            <svg width="26" height="39" viewBox="0 0 26 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25.065 34.4297L20.3058 39L0 19.5L20.3058 0L25.065 4.57031L9.51836 19.5L25.065 34.4297Z" fill="#FDFAF2"/>
            </svg>
          </Link>

          <h1 className="demozone__title__name">
            { localeFieldResolver(zoneData, 'title', activeLangState) }
          </h1>
        </div>

        <p className="demozone__description">{ localeFieldResolver(zoneData, 'description', activeLangState)}</p>

        {
          zoneData.webinar &&
          <div className="demozone__header__buttons">
            <a
              className="btn btn-primary btn--mobile-min bg-footer demozone__header__button"
              href={shouldRegister ? routes.REGISTER : zoneData.webinar }
              target="_blank"
              rel="noopener noreferrer"
            >
              { localizedName('webinarBtnTitle_ru') }
            </a>
            <p><i>{ localizedName('webinarBtnDesc_ru') }</i></p>
          </div>
        }

      </div>
      <div className="main-arrow">
        <Icon name="thin-arrow-down" />
      </div>
    </section>
  );
};

export default DemoZoneHeader;
